import { classSet } from '@umu/umu-dom';
import React from 'react';
import './index.scss'

interface IProps {
    checked?: boolean;
    disabled?: boolean;
}
export const RadioBox: React.FC<IProps> = ({ checked = false, disabled = false }) => {
    return (
        <div
            className={classSet({
                'radio-box': true,
                'checked': checked,
                'disabled': disabled,
            })}
        >
            <span className="input-block"></span>
        </div>
    );
};
